exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-826d9472]::-webkit-inner-spin-button,input[data-v-826d9472]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}", ""]);

// exports
